import {FC, PropsWithChildren, useCallback, useEffect, useMemo, useState} from 'react'
import {Input, notification, Select} from 'antd'
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom'
import {SearchOutlined} from '@ant-design/icons'
import {pathConstent, useUserInfoContext} from '@/store/userInfo'
import style from '../style.module.less'
import config from "@/config/env";

type PropType = FC<PropsWithChildren<{
    simple?: boolean
    className?: string
    type?: string
    filterFlag?: boolean
}>>
const menusData = [
    // {title: '全品类产品', key: 'product', code: pathConstent.QPLCP},
    // {title: 'DCA爆款机', key: 'dca', code: 'dcabkj'},
    // {title: '省代产品', key: 'sdcp', code: 'sdcp'},
    // {title: '手动工具', key: 'sdgjcp', code: 'sdgjcp'},
    // {title: '部件目录区', key: 'bjmlqpc', code: 'bjmlqpc'},
]
const Search: PropType = ({simple, className, type='product', filterFlag}) => {
    const {inventoryClass: inventoryClassOptions, inventoryClassNew,baseInfo} = useUserInfoContext()
    const [keyword, setKeyword] = useState(undefined)
    const [category, setCategory] = useState(undefined)
    const [menu, setMenu] = useState(undefined)
    const location = useLocation()
    const navigator = useNavigate()
    const [searchParams] = useSearchParams()
    const [menus, setMenus] = useState([])

    const inventoryClass = useMemo(() => {
        if (filterFlag) {
            return inventoryClassNew
        }
        return inventoryClassOptions
    }, [filterFlag, inventoryClassOptions, inventoryClassNew])

    const handleSearch = useCallback((val) => {
        const params = ['t=' + Date.now()]
        if (val) {
            params.push('keyword=' + val)
        }
        if (category) {
            params.push('lbbm=' + category)
        }
        if(location.pathname === '/allcpxx') {
            navigator('/allcpxx?' + params.join('&'))
        }else {
            window.open('/allcpxx?keyword=' + val , '_blank')
        }
    }, [category, menu, navigator])
    // const handleSearch = useCallback((val) => {
    //     // if (type === 'dca') {
    //     //     if (val.length < 2) {
    //     //         notification.info({message: "搜索框查询规则", description: "请输入2个及以上（包括2个）的字符"})
    //     //         return
    //     //     }
    //     // }
    //     const params = ['t=' + Date.now()]
    //     if (val) {
    //         params.push('keyword=' + val)
    //     }
    //     if (category) {
    //         params.push('lbbm=' + category)
    //     }
    //     if (category) {
    //         params.push('menu=' + menu)
    //     }
    //     if (menu === 'dca') {
    //         navigator('/dca?' + params.join('&'))
    //     } else if (menu === 'product') {
    //         navigator('/product?' + params.join('&'))
    //     }else  if (menu === 'sdcp') {
    //         navigator('/sdcp?' + params.join('&'))
    //     }else  if (menu === 'sdgjcp') {
    //         navigator('/sdgjcp?' + params.join('&'))
    //     }else  if (menu === 'bjmlqpc') {
    //         navigator('/bjmlq?' + params.join('&'))
    //     }else {
    //         notification.info({message: "搜索框查询规则", description: "请选择类型"})
    //         return
    //     }
    //     // if (type === 'dca') {
    //     //     navigator('/dca?' + params.join('&'))
    //     // } else {
    //     //     navigator('/product?' + params.join('&'))
    //     // }
    // }, [category, menu, navigator])

    useEffect(() => {
        const lbbm = searchParams.get('lbbm')
        const keyword = searchParams.get('keyword')
        if ((type === 'dca' && location.pathname === '/dca') || (type === 'product' && location.pathname === '/product')) {
            if (lbbm) {
                const targetRow = inventoryClass.find(r => r.classcode === lbbm)
                if (targetRow) {
                    setCategory(targetRow.classcode)
                } else {
                    setCategory(undefined)
                }
            }
        }
        setKeyword(keyword || undefined)
        setMenu(type)
    }, [searchParams, inventoryClass, location, type, baseInfo.qx])

    return (
        <div className={`${style.search} ${simple ? '' : style['complex-search']} ${className || ''}`}>
            <Input.Search
                // addonBefore={
                //     <Select value={menu} placeholder="菜单" style={{width: '120px'}} onChange={setMenu}
                //             allowClear>
                //         {
                //             menus.map(row => <Select.Option value={row.key}
                //                                                      >{row.title}</Select.Option>)
                //         }
                //     </Select>
                // }
                enterButton={
                    <SearchOutlined style={{fontSize: 22}}/>
                }
                placeholder={menu==='sdgjcp'?"请输入您想要的订货编码或货号":"请输入您想要的产品型号名称或订货编码"}
                allowClear
                value={keyword}
                size={simple ? 'middle' : 'large'}
                onChange={(e) => setKeyword(e.target.value)}
                onSearch={handleSearch}
            />
        </div>
    )
}

export default Search
